export const capitalizeWords = (text) => {
    if (!text) return "";
    const raw = String(text);
    const trailingSpace = /\s$/.test(raw) ? " " : "";
    const core = raw.trim();
    if (!core) return raw;
    const capitalized = core
        .split(/\s+/)
        .filter(Boolean)
        .map(
            (word) =>
                word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
        )
        .join(" ");
    return capitalized + trailingSpace;
};

/**
 * onChangeCapture handler: title-cases free-text <input type="text"> values
 * before the field's own onChange reads e.target.value.
 * Opt out with the `data-no-capitalize` attribute (e.g. codes / reference numbers).
 */
export const capitalizeTextInputOnChange = (e) => {
    const el = e.target;
    if (!el || el.tagName !== "INPUT") return;
    if ((el.getAttribute("type") || "text").toLowerCase() !== "text") return;
    if (el.readOnly || el.hasAttribute("data-no-capitalize")) return;
    // react-select search boxes
    if (el.hasAttribute("aria-autocomplete")) return;

    const current = el.value;
    const next = capitalizeWords(current);
    if (next === current) return;

    const { selectionStart, selectionEnd } = el;
    const lengthDelta = next.length - current.length;
    el.value = next;
    if (selectionStart != null && selectionEnd != null) {
        el.setSelectionRange(
            Math.max(0, selectionStart + lengthDelta),
            Math.max(0, selectionEnd + lengthDelta)
        );
    }
};
